
/**
 * @fileOverview CheckboxToggleController module definition
 */

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('controllers/CheckboxToggleController',['require','jquery','lib/Util'],function(require) {
        var $ = require('jquery');
        var Util = require('lib/Util');

        /**
         * This is a controller script that sees if a checkbox is checked and then toggles the visibility of
         * the label and a second element.
         *
         * @class CheckboxToggleController
         * @param {jQuery} $element A reference to the containing DOM element
         * @constructor
         */
        var CheckboxToggleController = function($element) {
            /**
             * A reference to the containing DOM element
             *
             * @default null
             * @property $element
             * @type {jQuery}
             * @public
             */
            this.$element = $element;

            /**
             * Class used added to objects in order to hide them.
             *
             * @default 'toggleIsHidden'
             * @property TOGGLE_HIDDEN_CLASS
             * @type {string}
             * @private
             */
            this.TOGGLE_HIDDEN_CLASS = 'toggleIsHidden';

            /**
             * This is the actual checkbox which the event is bound to.
             *
             * NOTE: This should be a jquery selector
             *
             * @default 'toggleIsHidden'
             * @property TOGGLE_TOGGLE_BOX_CLASS
             * @type {string}
             * @private
             */
            this.TOGGLE_BOX_CLASS = '.js-toggleCheckbox';

            /**
             * This is the label of the checkbox
             *
             * NOTE: This should be a jquery selector
             *
             * @default 'toggleIsHidden'
             * @property TOGGLE_LABEL_CLASS
             * @type {string}
             * @private
             */
            this.TOGGLE_LABEL_CLASS = '.js-toggleLabel';

            /**
             * This is the other item that switches places with the label
             *
             * NOTE: This should be a jquery selector
             *
             * @default 'toggleIsHidden'
             * @property TOGGLE_SUBMIT_CLASS
             * @type {string}
             * @private
             */
            this.TOGGLE_SUBMIT_CLASS = '.js-toggleSubmit';

            /**
             * Tracks whether component is enabled.
             *
             * @default false
             * @property isEnabled
             * @type {bool}
             * @public
             */
            this.isEnabled = false;

            this.init();
        };

        /**
         * Initializes the UI Component View
         * Runs a single setupHandlers call, followed by createChildren and layout
         * Exits early if it is already initialized
         *
         * @method init
         * @returns {CheckboxToggleController}
         * @private
         */
        CheckboxToggleController.prototype.init = function() {
            this.setupHandlers()
                .createChildren()
                .enable();
            $debug('CheckboxToggleController.js loaded');
            return this;
        };

        /**
         * Binds the scope of any handler functions
         * Should only be run on initialization of the view
         *
         * This creates event handlers and binds the scope
         * of the JS.
         *
         * @method setupHandlers
         * @returns {CheckboxToggleController}
         * @private
         */
        CheckboxToggleController.prototype.setupHandlers = function() {
            // Bind event handlers scope here
            this.onClickHandler = this.onClick.bind(this);

            return this;
        };

        /**
         * Create any child objects or references to DOM elements
         * Should only be run on initialization of the view
         *
         * @method createChildren
         * @returns {CheckboxToggleController}
         * @private
         */
        CheckboxToggleController.prototype.createChildren = function() {
            this.toggleCheckbox = this.$element.find(this.TOGGLE_BOX_CLASS);
            this.toggleLabel = this.$element.find(this.TOGGLE_LABEL_CLASS);
            this.toggleSubmit = this.$element.find(this.TOGGLE_SUBMIT_CLASS);

            return this;
        };

        /**
         * Remove any child objects or references to DOM elements
         *
         * @method removeChildren
         * @returns {CheckboxToggleController}
         * @public
         */
        CheckboxToggleController.prototype.removeChildren = function() {
            this.toggleCheckbox = null;
            this.toggleLabel = null;
            this.toggleSubmit = null;

            return this;
        };

        /**
         * Enables the component
         * Performs any event binding to handlers
         * Exits early if it is already enabled
         *
         * @method enable
         * @returns {CheckboxToggleController}
         * @public
         */
        CheckboxToggleController.prototype.enable = function() {
            if (this.isEnabled) {
                return this;
            }
            this.isEnabled = true;

            this.$element.on('change', this.toggleCheckbox, this.onClickHandler);

            return this;
        };

        /**
         * Disables the component
         * Tears down any event binding to handlers
         * Exits early if it is already disabled
         *
         * @property disable
         * @returns {CheckboxToggleController}
         * @public
         */
        CheckboxToggleController.prototype.disable = function() {
            if (!this.isEnabled) {
                return this;
            }
            this.isEnabled = false;

            this.$element.off('change', this.toggleCheckbox, this.onClickHandler);

            return this;
        };

        /**
         * Destroys the component
         * Tears down any events, handlers, elements
         * Should be called when the object should be left unused
         *
         * @method destroy
         * @returns {CheckboxToggleController}
         * @public
         */
        CheckboxToggleController.prototype.destroy = function() {
            this.disable()
                .removeChildren();
            return this;
        };

        //////////////////////////////////////////////////////////////////////////////////
        // EVENT HANDLERS
        //
        // Place events here, use event handlers to access it
        //////////////////////////////////////////////////////////////////////////////////

        /**
         * onClick handler
         * Something Happens on click
         *
         * @method onClick
         * @param {Event} e JavaScript event object
         * @private
         */

        CheckboxToggleController.prototype.onClick = function(e) {
            if (this.toggleCheckbox.is(':checked')) {
                this.toggleSubmit.removeClass(this.TOGGLE_HIDDEN_CLASS);
                this.toggleLabel.addClass(this.TOGGLE_HIDDEN_CLASS);
            } else {
                this.toggleLabel.removeClass(this.TOGGLE_HIDDEN_CLASS);
                this.toggleSubmit.addClass(this.TOGGLE_HIDDEN_CLASS);
            }

        };

        return CheckboxToggleController;
    });

}(MMMRequire));

